<template>
  <div>
    <v-dialog
      max-width="550px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Employee Skills
          <v-spacer></v-spacer>
          <v-text-field
            dense
            hide-details
            v-model="search"
            append-icon="mdi-magnify"
            label="Search skill"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-data-table
            dense
            :headers="employee_skills_headers"
            :items="employee_skills"
            :items-per-page="10"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 50, -1]
            }"
          >
            <template v-slot:[`item.Can_Delete`]="{ item }">
              <v-btn
                icon
                small
                @click.prevent="getEmployeeSkillCategoryById(item.Dev_Skills_Category_ID)"
                color="primary"
              >
                <v-icon>mdi-pencil-circle</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                :disabled="!item.Can_Delete"
                color="red darken-2"
                @click.prevent="deleteEmployeeSkillCategory(item.Dev_Skills_Category_ID)"
              >
                <v-icon>mdi-delete-circle</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="success" @click="addNewEmployeeSkillCategory">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="deleteEmployeeSkillCategoryDialog"
      v-model="deleteEmployeeSkillCategoryDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="removeEmployeeSkillCategory"
      @onCancelClick="deleteEmployeeSkillCategoryDialog = false"
      @onCloseClick="deleteEmployeeSkillCategoryDialog = false"
    />
    <EmployeeSkillsEditor
      v-model="showEmployeeSkillEditor"
      :addMode="addMode"
      :currentCategory="selectedEmployeeSkillsCategory"
      :employeeSkillsSubcategories="employee_skills_subcategories"
    ></EmployeeSkillsEditor>
  </div>
</template>
<script>

export default {
  name: 'EmployeeSkillsManager',
  props: {
    value: {
      required: false
    }
  },
  components: {
    EmployeeSkillsEditor: () => import('@/components/employee_skills/EmployeeSkillsEditor.vue'),
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  data () {
    return {
      addMode: false,
      showEditor: false,
      selectedEmployeeSkillsCategory: {},
      search: '',
      employee_skills: [],
      employee_skills_subcategories: [],
      deleteEmployeeSkillCategoryDialog: false,
      employee_skills_headers: [
        {
          text: 'ID',
          value: 'Dev_Skills_Category_ID',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Category Name',
          value: 'Dev_Skills_Category_Description',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: '',
          value: 'Can_Delete',
          cellClass: 'px-2 text-no-wrap',
          class: 'px-2 text-no-wrap',
          width: '5%',
          sortable: false
        }
      ]
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    showEmployeeSkillEditor: {
      get () {
        return this.showEditor
      },
      set (value) {
        if (!value) {
          this.getEmployeeSkills()
        }
        this.showEditor = value
      }
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  mounted () {
    this.getEmployeeSkills()
  },
  methods: {
    getEmployeeSkills () {
      this.axios.get('/api/employee_skills/categories', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.employee_skills = res.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getEmployeeSkillCategoryById (id) {
      this.axios.get(`/api/employee_skills/category/${id}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.selectedEmployeeSkillsCategory = res.data[0][0]
        this.employee_skills_subcategories = res.data[1]
        this.addMode = false
        this.showEmployeeSkillEditor = true
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    addNewEmployeeSkillCategory () {
      this.selectedEmployeeSkillsCategory = {
        Dev_Skills_Category_ID: null,
        Dev_Skills_Category_Description: ''
      }
      this.employee_skills_subcategories = []
      this.showEmployeeSkillEditor = true
      this.addMode = true
    },
    deleteEmployeeSkillCategory (id) {
      this.selectedEmployeeSkillsCategory.Dev_Skills_Category_ID = id
      this.deleteEmployeeSkillCategoryDialog = true
    },
    removeEmployeeSkillCategory () {
      this.axios.delete(`/api/employee_skills/category/${this.selectedEmployeeSkillsCategory.Dev_Skills_Category_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.employee_skills.splice(this.employee_skills.indexOf(item => item.ID === this.selectedEmployeeSkillsCategory.Dev_Skills_Category_ID), 1)
        this.$store.dispatch('setSuccess', { successMsg: 'Category succesefully deleted' })
        this.deleteEmployeeSkillCategoryDialog = false
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  }
}
</script>
